import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Typography from 'carbon-react/lib/components/typography';

import { Sidebar } from '@futrli/ui-components';
import { useSidebarResetCounter } from '@futrli/predict/hooks/useSidebarResetCounter/useSidebarResetCounter';

import { InviteUserContainer } from './containers/invite-user-container';
import { InviteUserContextProvider } from './context/invite-user-context';

interface InviteUserSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  workspaceId: string;
}

export const InviteUserSidebar = ({ isOpen, onClose, workspaceId }: InviteUserSidebarProps) => {
  const intl = useIntl();
  const { resetKey } = useSidebarResetCounter(isOpen);

  return (
    <Sidebar
      aria-label={intl.formatMessage({
        id: 'common.add_user_sidebar.aria_label',
        defaultMessage: 'Add a user sidebar'
      })}
      header={
        <Typography fontWeight="700" variant="h2">
          <FormattedMessage id="predict.workspaces.users.invite_new_user" defaultMessage="Invite a new user" />
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
      size="medium-large"
    >
      <InviteUserContextProvider key={resetKey} workspaceId={workspaceId}>
        <InviteUserContainer onClose={onClose} />
      </InviteUserContextProvider>
    </Sidebar>
  );
};
